function initialState () {
  return {
    authData: null,
    isLoggedIn: false,
    userData: null,
  };
}

export default {
  namespaced: true,
  state: {
    authData: null,
    isLoggedIn: false,
    userData: null,
  },
  getters: {
    authData ({ authData }) {
      return authData;
    },
    isLoggedIn ({ isLoggedIn }) {
      return isLoggedIn;
    },
    user ({ userData }) {
      return userData && userData.subject;
    },
    accessToken ({ authData }) {
      return authData && authData.access_token;
    },
  },
  actions: {
    async fetchAccessToken ({ commit, dispatch }) {
      let data;
      try {
        const response = await fetch('/identity/access/token');
        if (response.ok) {
          data = await response.json();
          commit('setAuthData', data);
          await dispatch('fetchUserProfile');
        }
      } catch (err) {
        console.error(err);
      }
    },
    fetchUserProfile ({ commit }) {
      fetch('/identity/me').then((response) => {
        return response.json();
      })
        .then((data) => {
          commit('setUserData', data);
        });
    },
    clear ({ commit }) {
      commit('clear');
    },
  },
  mutations: {
    setAuthData (state, data) {
      state.authData = data;
      state.isLoggedIn = true;
    },
    setUserData (state, data) {
      state.userData = data;
    },
    clear (state) {
      Object.assign(state, initialState());
    },
  },
};
